import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Output,
  ViewChild,
  Input,
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatSidenav, MatSidenavModule } from "@angular/material/sidenav";

@Component({
  selector: "app-filter",
  standalone: true,
  imports: [MatSidenavModule, MatIconModule, MatButtonModule, CommonModule],
  templateUrl: "./filter.component.html",
  styleUrl: "./filter.component.scss",
})
export class FilterComponent {
  @ViewChild("sidenav") sidenav!: MatSidenav;

  @Input() isOpened: boolean = false;
  @Output() onFilterEvent = new EventEmitter<void>();
  @Output() onCleanEvent = new EventEmitter<void>();
  @Output() onPanelOpened = new EventEmitter<void>(); // Nuevo output

  // Flag to track if the panel has been opened at least once
  hasBeenOpened = false;

  togglePanel(): void {
    this.isOpened = !this.isOpened;
    if (this.isOpened && !this.hasBeenOpened) {
      this.hasBeenOpened = true;
      this.onPanelOpened.emit();
    }
  }

  onFilter(): void {
    this.onFilterEvent.emit();
    this.togglePanel();
  }

  onClean(): void {
    this.onCleanEvent.emit();
    this.togglePanel();
  }

  preventScroll(event: WheelEvent) {
    event.preventDefault();
    event.stopPropagation();
  }
}
